<div class="assets-deposit">
  <ng-container *ngIf="kind === '3a' && selectedChip === 1; else regularTitle">
    <p><strong>{{'sp.revamp.3a.yearlyDeposit.title' | translate}}</strong></p>
  </ng-container>
  <ng-template #regularTitle>
    <p><strong>{{'sp.revamp.monthlyDeposit.title' | translate}}</strong></p>
  </ng-template>
  <form [formGroup]="depositForm" (ngSubmit)="onSetDeposit()">
    <ng-container *ngIf="showPlaceholder">
      <div class="assets-deposit-placeholder" (click)="onSelectInput()" [class.error]="inputError?.length">
        <span>{{currency}}</span>
        <span>{{ assetControl?.value.toFixed(0) | thousand }}</span>
      </div>
      <div *ngIf="kind === '3a'" class="assets-deposit-progress">
        <div class="bar">
          <div class="progress" [ngStyle]="{'width.%': progressPercentage}"></div>
        </div>
        <div class="values">
          <div>min {{ minimumInput.toFixed(0) | thousand: currency }}</div>
          <div>max {{ maximumInput.toFixed(0) | thousand: currency }}</div>
        </div>
      </div>
      <div *ngIf="inputError?.length" class="assets-deposit-error">
        <ion-icon name="cross-circle"></ion-icon>
        <p>{{ ('sp.revamp.monthlyDeposit.error.' + inputError) | translate:{value:limitedValue.toFixed(0) | thousand: currency} }}</p>
      </div>
      <button type="button" (click)="onSelectInput()">{{'sp.revamp.monthlyDeposit.adjustBTN' | translate}}</button>
    </ng-container>

    <ng-container *ngIf="!showPlaceholder">
      <div class="assets-deposit-amount">
        <div class="assets-deposit-label"><label for="value">{{currency}}</label></div>
        <div class="assets-deposit-input">
          <input
            type="number"
            id="value"
            autocomplete="false"
            inputmode="numeric"
            maxlength="9"
            min="0"
            #amountInput
            class="assets-deposit-input"
            formControlName="asset"
          />
        </div>
        <div *ngIf="kind === '3a'" class="assets-deposit-progress">
          <div class="bar">
            <div class="progress" [ngStyle]="{'width.%': progressPercentage}"></div>
          </div>
          <div class="values">
            <div>min {{ minimumInput.toFixed(0) | thousand: currency }}</div>
            <div>max {{ maximumInput.toFixed(0) | thousand: currency }}</div>
          </div>
        </div>
      </div>
      <button type="submit">{{'SHARED.actions.saveChanges' | translate}}</button>
      <ion-button (click)="onResetDefault()" mode="ios" color="white" class="outline">
        {{ 'SHARED.actions.discardChanges' | translate }}
      </ion-button>
    </ng-container>
  </form>
</div>
